import { render } from "./ReceiveRecords.vue?vue&type=template&id=57b15d87&scoped=true"
import script from "./ReceiveRecords.vue?vue&type=script&lang=js"
export * from "./ReceiveRecords.vue?vue&type=script&lang=js"

import "./ReceiveRecords.vue?vue&type=style&index=0&id=57b15d87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b15d87"]])

export default __exports__